import { Outlet } from 'react-router'

import ModalStack from 'js/components/ModalStack'
import { Toast } from 'js/components/Toast'
import ThemeProvider from 'js/theme/ThemeProvider'

const BaseLayout = () => {
    return (
        <ThemeProvider isRoot theme="site" bodyColor="#F5F5F5">
            <Outlet />
            <ModalStack />
            <Toast />
        </ThemeProvider>
    )
}

export default BaseLayout
